import utils from 'utils';

import {UiCheckbox} from '@components/export';
import {useLabel} from '@/hooks/export';

export const CartDeliveryOption = (props: {
    option: any, // fixme: delivery option type from BE config
    readonly: boolean,
    onChange: (selected: boolean) => void,
}) => {
    const label = useLabel();

    return <div className={cmpClass}>
        <div className={
            classMap.label +
            (props.option.selected ? ' ' + classMap.labelSelected : '')
        }>
            <p>
                <span>{props.option.name}</span>
                {
                    props.option.locationLink ?
                        <>
                            <span>{' ('}</span>
                            <span>
                                <a
                                    href={props.option.locationLink}
                                    target="_blank"
                                    rel="noreferrer"
                                    className={classMap.locationLink}
                                >
                                    {props.option.locationAddress}
                                </a>
                            </span>
                            <span>{')'}</span>
                        </> : <></>
                }
            </p>
            <p>
                <span className={classMap.message}>{props.option.message}</span>
            </p>
        </div>

        <div className={classMap.box}>
            {
                props.option.price ?
                    <div className={classMap.price}>
                        {utils.formatPrice(props.option.price) + ' ' + label.currency}
                    </div> : <></>
            }
            {
                !props.readonly ?
                    <UiCheckbox
                        onChange={(selected) => props.onChange(selected)}
                        checked={props.option.selected}
                        disabled={props.option.disabled}
                        hidden={!props.option.selectable}
                    /> : <></>
            }
        </div>
    </div>;
};

const cmpClass = 'cart-delivery-option';
const classMap = utils.generateClassMap(cmpClass, {
    label: 'label',
    labelSelected: 'label--selected',
    box: 'box',
    price: 'price',
    locationLink: 'location-link',
    message: 'message',
});
